import React, { useRef, useState } from 'react';
import * as Yup from "yup";
import Switch from "react-bootstrap-switch";
import moment from "moment";
import { useForm } from "react-hook-form";
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';

import SelectGeneric from "../../../components/select/selectGeneric";
import PromotionLangs from "./_langs";
import {
    ButtonCancel,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import { showToastCustom } from "../../../components/toast/customToast";
import { categoryPromotionProvider } from "../../../providers/categoryPromotionProvider";
import {
    FL_CAT_PROM, FL_CODE, FL_COUPON, FL_END_DATE, FL_IMAGE, FL_ORDER, FL_PAX_MAX, FL_PAX_MIN,
    FL_START_DATE, FL_STATUS, FL_TAX_INCLUDED, FL_TOP_PREFERENCE, FL_USE_PAX_TO_PRICES,
} from "../../../components/i18n/formLabels";
import { PH_CODE, PH_COUPON, PH_IMAGE, PH_PAX_MAX, PH_PAX_MIN } from "../../../components/i18n/placeHolders";
import { error, FORM, INTERNATIONAL, REQUIRED, selectOption } from "../../../components/i18n/i18n";
import { TT_HISTORY } from "../../../components/i18n/toolTips";
import { LogHistoryModal } from "../../../components/logHistory/logHistoryModal";
import {setLoading, setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {resetCombos, setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {save, update} from "../../../redux/actions/promo/promotionActions";
import {connect} from "react-redux";
import {getCurrentDateForCodeField} from "../../../util/DateTools";

const PromotionForm = (props) => {
    const toDate = moment(new Date()).format('YYYY-MM-DD')
    const { editMode, disableInputs, domainObject } = props.formProps;
    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id;

    const [langs, setlangs] = useState(domainObject?.langs || []);

    const [categoryPromotionId, setCategoryPromotionId] = useState( editMode ? domainObject?.categoryPromotion?.id : null);
    const [startDate, setStartDate] = useState(editMode ? domainObject?.startDate : null);
    const [endDate, setEndDate] = useState(editMode ? domainObject?.endDate : null);
    const [cotizationDate, setCotizationDate] = useState(editMode ? domainObject?.cotizationDate : null);

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED )
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            uid: domainObject?.uid,
            code: (domainObject?.code || 'promo_' + getCurrentDateForCodeField()), // AUTOCODE
            coupon: domainObject?.coupon,
            showOrder: domainObject?.showOrder,
            defaultImage: domainObject?.defaultImage,
            paxMax: domainObject?.paxMax,
            paxMin: domainObject?.paxMin,
            daysPrev: domainObject?.daysPrev,
            startDate,
            endDate,
            cotizationDate,
        }
    });

    const onSubmit = (data, _) => {
        if (categoryPromotionId == null)
            return showToastCustom(error, selectOption);

        let dataRequest = {
            noDb : false,
            allDb : false,
            fbDataBase :  { id : fbDataBaseId },
            item : {
                ...data,
                langs : langs,
                //Booleans
                status: domainObject?.status || false,
                taxIncluded: domainObject?.taxIncluded || false,
                topPreference: domainObject?.topPreference || false,
                useMaxMinToGetPrice: domainObject?.useMaxMinToGetPrice || false,
                //End booleans
                startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : null,
                endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : null,
                categoryPromotion: { id : categoryPromotionId },
                cotizationDate: cotizationDate ? moment(cotizationDate).format('YYYY-MM-DD') : null,
            }
        };

        dataRequest.item.langs.map(lang => {
            lang.fbDataBase = { id: fbDataBaseId }
        })

        // console.log(dataRequest);
        // return;

        setLoading(true);

        if (editMode) {
            let id = domainObject?.id;
            dataRequest.item.id = id

            props.update(id, dataRequest)
        } else {
            props.save(dataRequest)
        }

        returnToList()
    };

    const returnToList = () => {
        reset();
        props.setItem(null);
        props.setForm(false, false, false);
        props.setViewMode("LIST");
    }

    const handleSwitchs = (field) => {
        const tmpObject = JSON.parse(JSON.stringify(domainObject)) || {}
        tmpObject[field] = tmpObject[field] ? !tmpObject[field] : true
        props.setItem(tmpObject)
    }


    return (<>
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="2">
                            <FormGroup>
                                <Label>{FL_CODE}</Label>
                                <Input
                                    type="text"
                                    name="code"
                                    placeholder={PH_CODE}
                                    innerRef={register}
                                    disabled={disableInputs}
                                    className={(errors.code ? ' is-invalid' : '')}
                                />
                                {errors.code && <div className="invalid-feedback"
                                                     style={{'display': 'block'}}>{errors?.code?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{FL_COUPON}</Label>
                                <Input type="text" name="coupon"
                                       placeholder={PH_COUPON}
                                       innerRef={register}
                                       disabled={disableInputs}/>
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{FL_ORDER}</Label>
                                <Input type="number" name="showOrder"
                                       innerRef={register}
                                       disabled={disableInputs}/>
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{FL_IMAGE}</Label>
                                <Input type="text" name="defaultImage"
                                       placeholder={PH_IMAGE}
                                       innerRef={register}
                                       disabled={disableInputs}/>
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>{FL_CAT_PROM}</Label>
                                <br/>
                                <SelectGeneric
                                    isDisabled={disableInputs}
                                    initialValue={categoryPromotionId}
                                    setExternalValue={setCategoryPromotionId}
                                    provider={categoryPromotionProvider}
                                    //resetValue={resetValues}
                                    fbDataBaseId={fbDataBaseId}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="2">
                            <FormGroup>
                                <Label>{FL_PAX_MAX}</Label>
                                <Input
                                    type="text"
                                    name="paxMax"
                                    placeholder={PH_PAX_MAX}
                                    innerRef={register}
                                    disabled={disableInputs}
                                    pattern='([0-9]+\/[0-9]+)'
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{FL_PAX_MIN}</Label>
                                <Input
                                    type="text"
                                    name="paxMin"
                                    placeholder={PH_PAX_MIN}
                                    innerRef={register}
                                    disabled={disableInputs}
                                    pattern='([0-9]+\/[0-9]+)'
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{FL_STATUS}</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={domainObject?.status || false}
                                        onChange={() => handleSwitchs('status')}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{FL_TAX_INCLUDED}</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={domainObject?.taxIncluded || false}
                                        onChange={() => handleSwitchs('taxIncluded')}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{FL_TOP_PREFERENCE}</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={domainObject?.topPreference || false}
                                        onChange={() => handleSwitchs('topPreference')}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{FL_USE_PAX_TO_PRICES}</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={domainObject?.useMaxMinToGetPrice || false}
                                        onChange={() => handleSwitchs('useMaxMinToGetPrice')}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="2">
                            <Label>{FL_START_DATE}</Label>
                            <Input
                                type="date"
                                name="startDate"
                                value={startDate || ''}
                                min={startDate || toDate}
                                disabled={disableInputs}
                                onChange={e => setStartDate(e.target.value)}
                                innerRef={register}
                            />
                        </Col>
                        <Col md="2">
                            <Label>{FL_END_DATE}</Label>
                            <Input
                                type="date"
                                name="endDate"
                                value={endDate || ''}
                                min={startDate || toDate}
                                disabled={disableInputs}
                                onChange={e => setEndDate(e.target.value)}
                                innerRef={register}
                            />
                        </Col>
                        <Col md="3">
                            <Label>{'Cotizar con fecha exacta'}</Label>
                            <Input
                                type="date"
                                name="cotizationDate"
                                value={cotizationDate || ''}
                                disabled={disableInputs}
                                onChange={e => setCotizationDate(e.target.value)}
                                innerRef={register}
                            />
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>{'Cotizar con dias de antelación'}</Label>
                                <Input type="number"
                                       name="daysPrev"
                                       step={1}
                                       min={0}
                                       innerRef={register}
                                       disabled={disableInputs}/>
                            </FormGroup>
                        </Col>
                    </Row>

                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>{INTERNATIONAL}
                    </CardTitle>
                    <CardBody>
                        <PromotionLangs langs={langs} setLangs={setlangs} translatableLangs={domainObject?.translatedLangs || []}/>
                    </CardBody>
                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                            <ButtonCancel onClick={returnToList}/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
        </Card>

        {
            showModal && <LogHistoryModal
                ref={ modalRef }
                item={ domainObject }
            />
        }
    </>)
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    save,
    update,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(PromotionForm)
